/**
 * 获取指定用户的粉丝数和关注数
 * @param id 用户ID
 * @returns 用户粉丝数和关注数
 */
export async function fetchUserFollowAndFansById(id: number): Promise<{
  follow: number
  fans: number
}> {
  return http
    .get<{
      follow: number
      fans: number
    }>('/v1/follow/count', {
      user_id: id
    })
    .then((res) => res.data)
    .catch(() => {
      return {
        follow: 0,
        fans: 0
      }
    })
}
